import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Utilities, _isUndefined, isFooterTab } from '../Utilities/Utilities';
import { MyContext } from './MyProvider';
import { MyWallet, Transaction, AddFunds, Withdraw, PaymentMethod,BuyCoins } from "../Component/Finance";
import { LandingScreen, TermsCondition, RulesScoring, PrivacyPolicy, FAQ, AboutUs, HowToPlay, ContactUs, Offers,Legality, HowItWorks,NewRulesScoring } from "../Component/StaticPages";
import { ForgotEmailPassword, ResetPassword, ChangePassword, EmailLogin, SetPassword, VerifyEmail, UpdateMobileNo, EnterPassword } from "../Component/OnBoarding/EmailFlow";
import { MobileLogin, VerifyMobile, PickUsername, ReferralCode, PickEmail, PickMobileNo, } from "../Component/OnBoarding/MobileFlow";
import { MyContest } from '../Component/MyContest';
import { Profile, ProfileEdit, VerifyAccount, PanVerification, BankVerification } from "../Component/Profile";
import ScrollMemory from 'react-router-scroll-memory';
import WSManager from "../WSHelper/WSManager";
import Contest from "../views/Contest";
import createContest from "../views/CreateContest";
import LeaderBoard from "../views/Leaderboard";
import UserNotification from '../views/Notification';
import RefferalSystem from "../views/ReferralSystem";
import HaveALeagueCodeClass from '../views/HaveALeagueCodeClass';
import MyTeams from "../views/MyTeams";
import { MultiGameContest } from '../Component/MultiGameModule';
import ReferalLeaderBoard from '../views/ReferalLeaderBoard';

import SelectCaptainList from "../views/SelectCaptainList";
import Roster from "../views/Roster";
import ContestListing from "../views/ContestListing";
import ReferFriend from '../views/ReferFriend';
import Dashboard from "../views/Dashboard";
import PageNotFound from '../views/PageNotFound/PageNoFound';
import Loadable from 'react-loadable';
import CustomLoader from '../helper/CustomLoader';
import TeamComparison from '../views/Leaderboard/TeamComparison';
import CricketScorecard from '../Component/scorecard/CricketScorecard';

function LoadingComponent(showHeader) {
    return <div className="web-container bg-white">{showHeader && <div className="app-header-style" />}<CustomLoader /></div>;
}
const AppInstallNotification = Loadable({
    loader: () => import('../views/AppInstallNotification'),
    delay: 0,
    loading: ()=> <div />
});
const SidePage = Loadable({
    loader: () => import('../views/SidePage'),
    delay: 0,
    loading: ()=> <div />
});
const YouRInQueue = Loadable({
    loader: () => import('../Component/CustomComponent/YouRInQueue'),
    delay: 0,
    loading: ()=> <div />
});
const EditReferralCode = Loadable({
    loader: () => import('../views/EditReferralCode'),
    delay: 0,
    loading: ()=> LoadingComponent(true)
});
const FieldView = Loadable({
    loader: () => import('../views/FieldView'),
    delay: 0,
    loading: ()=> <div />
});

const SportsHub = Loadable({
    loader: () => {
        if (Utilities.getMasterData().sports_hub && Utilities.getMasterData().sports_hub.length > 1)
            return import('../Component/SportsHub/SportsHub')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});
const EarnCoins = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/CoinsModule/EarnCoins')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});

const RedeemCoins = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/CoinsModule/RedeemCoins')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});
const WhatIsNew = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/CoinsModule/WhatIsNew')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});

const FeedbackQA = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/CoinsModule/FeedbackQA')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});

const PredictionContestList = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/PredictionModule/PredictionContestList')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});

const PredictionShare = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/PredictionModule/SharePrediction')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});
const PredictionParticipants = Loadable({
    loader: () => {
        if (Utilities.getMasterData().a_coin)
            return import('../Component/PredictionModule/PredictionParticipants')
        else
            return import('../views/PageNotFound/PageNoFound')
    },
    delay: 0,
    loading: ()=> LoadingComponent(true)
});

class Routing extends React.Component {
    constructor(params) {
        super(params);
        this.state = {
            installNotificationShow: true,  
            popupStatus: WSManager.getPopupStatus()          
        };        
    }

    componentDidMount() {
        window.addEventListener('online', this.updateIndicator);
        window.addEventListener('offline', this.updateIndicator);
        window.location.href= 'https://app.fantasyakhada.com'
    }

    updateIndicator=()=>{
        let internetStatus = '';
        if(navigator.onLine) { 
            internetStatus = true ;// for online
        }
        else{
            internetStatus = false ;// for offline
        }
        if(!internetStatus){
            Utilities.showToast("You're offline right now. Check your connection.", 4000)
        }
    }

    closeInstallNotification = () => {
        this.setState({ installNotificationShow: false })
        WSManager.closeInstallPopup();
    }

    render() {

        const PrivateRoute = ({ component: Component, ...rest }) => (
            <Route {...rest} render={(props) => (
                WSManager.loggedIn() === true
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: '/signup', state: { from: props.location } }} />
            )} />
        )

        const SequenceRoute = ({ component: Component, ...rest }) => (
            <Route {...rest} render={(props) => (
                (WSManager.loggedIn() === true && !_isUndefined(props.location.state))
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: "/lobby", state: { from: props.location } }} />
            )} />
        )

        const OnboardingRoute = ({ component: Component, ...rest }) => (

            <Route {...rest} render={(props) => (
                <React.Fragment>
                    {WSManager.loggedIn() === false ?
                        !_isUndefined(rest.location.state) || rest.path === '/signup'
                            ? <Component {...props} />
                            : <Redirect to={{ pathname: '/signup' }} />
                        : <Redirect to={"/lobby#" + Utilities.getSelectedSportsForUrl()} />
                    }
                </React.Fragment>
            )} />
        )

        const CoinRoute = ({ component: Component, ...rest }) => (

            parseInt(Utilities.getMasterData().a_coin || '0') === 1
                ?
                <Route {...rest} render={(props) => (<Component {...props} />)} />
                :
                <PageNotFound />
        )

        const DashboardPRoute = ({ component: Component, page_key: pageKey, ...rest }) => (
            isFooterTab(pageKey)
                ?
                <Route {...rest} render={(props) => (
                    WSManager.loggedIn() === true
                    ? <Dashboard {...props} />
                    : <Redirect to={{ pathname: '/signup', state: { from: props.location } }} />
                    )} />
                :
                <Route {...rest} render={(props) => (
                    WSManager.loggedIn() === true
                    ? <Component {...props} />
                    : <Redirect to={{ pathname: '/signup', state: { from: props.location } }} />
                )} />
        )

        return (
            <MyContext.Consumer>
                {(context) => (
                    <React.Fragment>
                        <Router>
                            <main className='Site'>
                                {
                                    !window.ReactNativeWebView && this.state.installNotificationShow && !this.state.popupStatus && <>
                                        <AppInstallNotification closeInstallNotification={this.closeInstallNotification} />
                                    </>
                                }                                
                                <div
                                    style={{
                                        backgroundImage: window.ReactNativeWebView ? '' : `url(${Utilities.getUploadURL(Utilities.getMasterData().bg_image)})`,
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                        backgroundRepeat: "no-repeat"
                                    }}
                                    className="Site-content">
                                    <ScrollMemory />
                                    <Switch>
                                        <Route path="/you-are-in-queue" component={YouRInQueue} exact />
                                        <Route path="/lobby" component={Dashboard} exact />
                                        <Route path="/" component={LandingScreen} exact />

                                        <SequenceRoute path="/lineup/:lineupKey" component={Roster} exact />
                                        <SequenceRoute path="/field-view/:fieldKey" component={FieldView} exact />

                                        <SequenceRoute path="/select-captain/:captainKey" component={SelectCaptainList} exact />

                                        {/* Onboarding */}
                                        <OnboardingRoute path="/signup" component={Utilities.getMasterData().login_flow === '1' ? EmailLogin : MobileLogin} exact />
                                        <OnboardingRoute path="/set-password" component={SetPassword} exact />
                                        <OnboardingRoute path="/password" component={EnterPassword} exact />
                                        <OnboardingRoute path="/verify" component={Utilities.getMasterData().login_flow === '1' ? VerifyEmail : VerifyMobile} exact />
                                        <OnboardingRoute path="/referral" component={ReferralCode} exact />
                                        <OnboardingRoute path="/pick-username" component={PickUsername} exact />
                                        <OnboardingRoute path="/email" component={PickEmail} exact />
                                        <OnboardingRoute path="/enter-email" component={ForgotEmailPassword} exact />
                                        <Route path="/forgot-password" component={ResetPassword} exact />
                                        <Route path="/pick-mobile" component={Utilities.getMasterData().login_flow === '1' ? UpdateMobileNo : PickMobileNo} exact />

                                        {/* Public */}
                                        <Route path="/:sportsId/contest-listing/:collection_master_id/:myKey" component={ContestListing} exact />
                                        <Route path="/:sportsId/contest/:contest_unique_id" component={Contest} exact />
                                        <Route path="/:sportsId/multigame-contest/:contest_unique_id" component={MultiGameContest} exact />
                                        <Route path="/:sportsId/my-teams/:collection_master_id/:myKey" component={MyTeams} exact />
                                        <Route path="/terms-condition" component={TermsCondition} exact />
                                        <Route path="/rules-and-scoring" component={RulesScoring} exact />
                                        <Route path="/new-rules-and-scoring" component={NewRulesScoring} exact />
                                        <Route path="/offers" component={Offers} exact />
                                        <Route path="/privacy-policy" component={PrivacyPolicy} exact />
                                        <Route path="/faq" component={FAQ} exact />
                                        <Route path="/about-us" component={AboutUs} exact />
                                        <Route path="/contact-us" component={ContactUs} exact />
                                        <Route path="/how-to-play" component={HowToPlay} exact />
                                        <Route path="/legality" component={Legality} exact />
                                        <Route path="/how-it-works" component={HowItWorks} exact />
                                        <Route path="/private-contest" component={HaveALeagueCodeClass} exact />
                                        <Route path="/payment-method" component={PaymentMethod} exact />
                                        <Route path="/:sportsId/prediction/contest-listing/:collection_master_id/:myKey" component={PredictionContestList} exact />
                                        <Route path="/:sportsId/prediction-details/:season_game_uid/:prediction_master_id" component={PredictionShare} exact />
                                        <Route path="/:sportsId/prediction/participants/:prediction_master_id" component={PredictionParticipants} exact />
                                        <Route path="/team-comparison" component={TeamComparison} exact />
                                        <PrivateRoute path="/leaderboard" component={Dashboard} exact />

                                        {/* Dashboard Private Screen */}
                                        <DashboardPRoute path="/my-contests" component={MyContest} page_key={'my-contests'} exact />
                                        <DashboardPRoute path="/my-profile" component={Profile} page_key={'my-profile'} exact />
                                        <DashboardPRoute path="/notification" component={UserNotification} page_key={'notification'} exact />
                                        <DashboardPRoute path="/refer-friend" component={ReferFriend} page_key={'refer-friend'} exact />
                                        <DashboardPRoute path="/refer-friend-leaderboard" component={ReferalLeaderBoard} page_key={'refer-friend-leaderboard'} exact />
                                        <DashboardPRoute path="/my-wallet" component={MyWallet} page_key={'my-wallet'} exact />
                                        <DashboardPRoute path="/buy-coins" component={BuyCoins} page_key={'my-wallet'} exact />
                                        
                                        {/* Coins*/}
                                        <CoinRoute path="/earn-coins" component={isFooterTab('earn-coins') ? Dashboard : EarnCoins} exact />
                                        <CoinRoute path="/rewards" component={RedeemCoins} exact />
                                        <CoinRoute path="/feedback" component={FeedbackQA} exact />
                                        <CoinRoute path="/what-is-new" component={WhatIsNew} exact />
                                        {/********/}

                                        <PrivateRoute path="/edit-profile" component={ProfileEdit} exact />
                                        <PrivateRoute path="/create-contest" component={createContest} exact />
                                        <PrivateRoute path="/:sportsId/leaderboard" component={LeaderBoard} exact />
                                        <PrivateRoute path="/transactions" component={Transaction} exact />
                                        <PrivateRoute path="/add-funds" component={AddFunds} exact />
                                        <PrivateRoute path="/withdraw" component={Withdraw} exact />
                                        <PrivateRoute path="/more" component={Dashboard} exact />
                                        <PrivateRoute path="/change-password" component={ChangePassword} exact />
                                        <PrivateRoute path="/verify-account" component={VerifyAccount} exact />
                                        <PrivateRoute path="/pan-verification" component={PanVerification} exact />
                                        <PrivateRoute path="/bank-verification" component={BankVerification} exact />
                                        <PrivateRoute path="/referral-system" component={RefferalSystem} exact />
                                        <PrivateRoute path="/edit-referral-code" component={EditReferralCode} exact />
                                        {SportsHub && <Route path="/sports-hub" component={SportsHub} exact />}
                                       
                                        {/* Scorecard */}                                        
                                        <Route path="/scorecard/:sportsId/:matchId" component={CricketScorecard} exact />
                                        
                                        {/* Default Page */}
                                        <Route component={PageNotFound} />
                                        
                                    </Switch>
                                    {!window.ReactNativeWebView && <SidePage />}
                                </div>
                            </main>
                        </Router>
                    </React.Fragment>
                )}
            </MyContext.Consumer>
        )
    }
}

export default Routing
